(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certifications-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var wraps = document.querySelectorAll('.nz-certs-marquee--scroll');

    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('.nz-certs-marquee__track');
      if (!track) return;

      var repeats = parseInt(wrap.dataset.certsRepeats, 10) || 4;
      var durationSeconds = parseFloat(wrap.dataset.certsSpeed) || 18;
      var pauseOnHover = wrap.dataset.certsPause === 'true';

      var setWidth = 0;
      var offset = 0;
      var lastTime = null;
      var isDragging = false;
      var isHovering = false;
      var isVisible = false;
      var initialized = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var dragMoved = false;

      function debounce(fn, wait) {
        var t;
        return function () {
          clearTimeout(t);
          t = setTimeout(fn, wait);
        };
      }

      function measure() {
        setWidth = track.scrollWidth / repeats;
      }

      function applyTransform() {
        if (!setWidth) {
          track.style.transform = 'translateX(0)';
          return;
        }
        var wrapped = ((offset % setWidth) + setWidth) % setWidth;
        track.style.transform = 'translateX(' + -wrapped + 'px)';
      }

      function tick(now) {
        if (!isVisible) return; // Fully stops the loop once scrolled out of view.
        if (lastTime === null) lastTime = now;
        var dt = now - lastTime;
        lastTime = now;

        if (!isDragging && setWidth > 0 && !(pauseOnHover && isHovering)) {
          offset += (setWidth / (durationSeconds * 1000)) * dt;
          applyTransform();
        }
        requestAnimationFrame(tick);
      }

      function bindInteractions() {
        track.addEventListener('pointerdown', function (e) {
          isDragging = true;
          dragMoved = false;
          dragStartX = e.clientX;
          dragStartOffset = offset;
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        });
        track.addEventListener('pointermove', function (e) {
          if (!isDragging) return;
          var delta = dragStartX - e.clientX;
          if (Math.abs(delta) > 3) dragMoved = true;
          offset = dragStartOffset + delta;
          applyTransform();
        });
        function endDrag() {
          isDragging = false;
          lastTime = null;
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('pointerleave', function () {
          if (isDragging) endDrag();
        });
        track.addEventListener('click', function (e) {
          if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        if (pauseOnHover) {
          wrap.addEventListener('mouseenter', function () { isHovering = true; });
          wrap.addEventListener('mouseleave', function () { isHovering = false; });
        }
      }

      // Defer measuring, listeners, and the animation loop until this strip is
      // actually near the viewport — so it never competes for main-thread time
      // during initial page load (e.g. with video/reel players elsewhere on the page).
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) {
            if (!initialized) {
              initialized = true;
              measure();
              window.addEventListener('resize', debounce(measure, 200));
              track.querySelectorAll('img').forEach(function (img) {
                if (!img.complete) img.addEventListener('load', measure, { once: true });
              });
              bindInteractions();
            }
            lastTime = null;
            requestAnimationFrame(tick);
          }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(wrap);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.querySelectorAll('.nz-article__share-copy').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const url = btn.dataset.shareUrl;
      try {
        await navigator.clipboard.writeText(url);
        const original = btn.textContent;
        btn.textContent = 'Copied';
        setTimeout(() => { btn.textContent = original; }, 1600);
      } catch {
        window.prompt('Copy this link:', url);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-reels"] && !Shopify.designMode) return;
  try {
    
  // Self-contained product-reels rail. Combines lazy video hydration with a
  // horizontal auto-scroll marquee that supports manual drag / swipe / wheel.
  // Scoped to [data-nz-pdp-reels-scroller] so it never collides with the
  // homepage nz-video-feed and supports multiple instances on one page.
  (function () {
    'use strict';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function play(video) {
      try {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    // Promote data-src → src individually per video, only once THAT video
    // nears the viewport — never all of them at once, and never on a blanket
    // "page finished loading" timer (that defeated lazy-loading entirely).
    function setupLazy(scroller) {
      function hydrateOne(video) {
        if (video.dataset.nzHydrated === 'true') return;
        video.dataset.nzHydrated = 'true';

        var sources = video.querySelectorAll('source[data-src]');
        if (!sources.length) return;
        sources.forEach(function (src) {
          src.setAttribute('src', src.getAttribute('data-src'));
          src.removeAttribute('data-src');
        });
        video.preload = 'auto';
        video.removeAttribute('data-nz-pdp-reels-video');
        try { video.load(); } catch (e) {}

        if (video.readyState >= 2) {
          play(video);
        } else {
          video.addEventListener('loadedmetadata', function () { play(video); }, { once: true });
          video.addEventListener('canplay', function () { play(video); }, { once: true });
        }
      }

      var allVideos = scroller.querySelectorAll('video[data-nz-pdp-reels-video]');

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              hydrateOne(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '300px 0px' });
        allVideos.forEach(function (v) { io.observe(v); });
      } else {
        allVideos.forEach(hydrateOne);
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        scroller.querySelectorAll('.nz-pdp-reels__video').forEach(function (v) {
          if (v.dataset.nzHydrated === 'true' && v.paused) play(v);
        });
      });
    }

    function initMarquee(el) {
      var track = el.querySelector('.nz-pdp-reels__track');
      if (!track) return;

      var duration = parseFloat(el.dataset.duration) || 40;
      // Liquid renders exactly two identical passes. Capture the pass size
      // BEFORE any cloning so the loop period stays correct after we extend.
      var cardsPerPass = Math.floor(track.children.length / 2);
      var half = 0;

      function measure() {
        var cards = track.children;
        if (cards.length <= cardsPerPass || cardsPerPass === 0) { half = 0; return; }
        half = cards[cardsPerPass].offsetLeft - cards[0].offsetLeft;
      }

      function ensureCoverage() {
        // Wrap point must be reachable via native scroll — append more passes
        // until the track is wider than the viewport by at least one pass. This
        // is what lets a single reel loop seamlessly.
        if (cardsPerPass === 0) return;
        measure();
        if (half <= 0) return;
        var guard = 8;
        while (track.scrollWidth - el.clientWidth < half + 1 && guard-- > 0) {
          for (var i = 0; i < cardsPerPass; i++) {
            var clone = track.children[i].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a').forEach(function (n) {
              n.setAttribute('tabindex', '-1');
            });
            track.appendChild(clone);
          }
        }
        measure();
      }
      ensureCoverage();

      window.addEventListener('resize', ensureCoverage);

      var pxPerMs = 0;
      function recomputeSpeed() {
        pxPerMs = duration > 0 ? half / (duration * 1000) : 0;
      }
      recomputeSpeed();

      var paused = reduceMotion.matches;
      var resumeTimer = null;
      var lastTime = null;
      // Track scroll position as a float — mobile browsers round el.scrollLeft
      // on read, so a sub-pixel-per-frame increment never accumulates via `+=`.
      var pos = el.scrollLeft;

      function pauseFor(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (!reduceMotion.matches) {
            pos = el.scrollLeft;
            paused = false;
            lastTime = null;
          }
        }, ms);
      }

      function step(t) {
        recomputeSpeed();
        if (lastTime === null) lastTime = t;
        var dt = t - lastTime;
        lastTime = t;
        if (!paused && half > 0 && pxPerMs > 0) {
          pos += pxPerMs * dt;
          if (pos >= half) pos -= half;
          el.scrollLeft = pos;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);

      el.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
      el.addEventListener('touchstart', function () { pauseFor(3000); }, { passive: true });
      el.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

      // Desktop pointer drag. Only enter drag mode once movement exceeds the
      // threshold, so a plain click still opens the reel link.
      var DRAG_THRESHOLD = 5;
      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;
      var activePointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isPointerDown = true;
        isDragging = false;
        moved = 0;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        activePointerId = e.pointerId;
        pauseFor(60000);
      });

      el.addEventListener('pointermove', function (e) {
        if (!isPointerDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!isDragging) {
          if (moved <= DRAG_THRESHOLD) return;
          isDragging = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(activePointerId); } catch (_) {}
        }
        var next = startScroll - dx;
        if (half > 0) {
          while (next < 0) {
            next += half;
            startScroll += half;
          }
          while (next >= half) {
            next -= half;
            startScroll -= half;
          }
        }
        el.scrollLeft = next;
      });

      function endDrag() {
        if (!isPointerDown) return;
        isPointerDown = false;
        var wasDragging = isDragging;
        isDragging = false;
        el.classList.remove('is-dragging');
        if (activePointerId !== null) {
          try { el.releasePointerCapture(activePointerId); } catch (_) {}
          activePointerId = null;
        }
        if (wasDragging) {
          var swallow = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            el.removeEventListener('click', swallow, true);
          };
          el.addEventListener('click', swallow, true);
        }
        pauseFor(1500);
      }
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      var onMotionChange = function () {
        if (reduceMotion.matches) {
          paused = true;
        } else {
          paused = false;
          lastTime = null;
        }
      };
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', onMotionChange);
      } else if (reduceMotion.addListener) {
        reduceMotion.addListener(onMotionChange);
      }
    }

    function init(scroller) {
      if (scroller.dataset.nzPdpReelsReady === '1') return;
      scroller.dataset.nzPdpReelsReady = '1';
      setupLazy(scroller);
      initMarquee(scroller);
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-nz-pdp-reels-scroller]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(el) {
      if (el.dataset.nzTestiReady === '1') return;
      el.dataset.nzTestiReady = '1';

      var track = el.querySelector('.nz-testi-scroller__track');
      if (!track) return;

      var duration = parseFloat(el.dataset.duration) || 55;
      // Liquid renders exactly two identical passes. Capture the pass size
      // BEFORE any cloning so the loop period stays correct after we extend.
      var cardsPerPass = Math.floor(track.children.length / 2);
      var half = 0;

      function measure() {
        var cards = track.children;
        if (cards.length <= cardsPerPass || cardsPerPass === 0) { half = 0; return; }
        half = cards[cardsPerPass].offsetLeft - cards[0].offsetLeft;
      }

      function ensureCoverage() {
        // Wrap point must be reachable via native scroll — append more passes
        // until the track is wider than the viewport by at least one pass.
        if (cardsPerPass === 0) return;
        measure();
        if (half <= 0) return;
        var guard = 8;
        while (track.scrollWidth - el.clientWidth < half + 1 && guard-- > 0) {
          for (var i = 0; i < cardsPerPass; i++) {
            var clone = track.children[i].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button').forEach(function (n) {
              n.setAttribute('tabindex', '-1');
            });
            track.appendChild(clone);
          }
        }
        measure();
      }
      ensureCoverage();

      window.addEventListener('resize', ensureCoverage);

      var pxPerMs = 0;
      function recomputeSpeed() {
        pxPerMs = duration > 0 ? half / (duration * 1000) : 0;
      }
      recomputeSpeed();

      var paused = reduceMotion.matches;
      var resumeTimer = null;
      var lastTime = null;
      // Track scroll position internally as a float. Mobile browsers (iOS
      // Safari in particular) round el.scrollLeft when read, so the
      // sub-pixel-per-frame increment never accumulates via `+=`.
      var pos = el.scrollLeft;

      function pauseFor(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (!reduceMotion.matches) {
            pos = el.scrollLeft;
            paused = false;
            lastTime = null;
          }
        }, ms);
      }

      function step(t) {
        recomputeSpeed();
        if (lastTime === null) lastTime = t;
        var dt = t - lastTime;
        lastTime = t;
        if (!paused && half > 0 && pxPerMs > 0) {
          pos += pxPerMs * dt;
          if (pos >= half) pos -= half;
          el.scrollLeft = pos;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);

      // Native swipe / wheel: pause briefly so the user keeps control. Matches
      // the proven nz-on-sale / nz-milind-picks rails — let the browser own the
      // scroll (native horizontal trackpad swipe + drag below) instead of
      // hijacking the wheel with preventDefault.
      el.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
      el.addEventListener('touchstart', function () { pauseFor(3000); }, { passive: true });
      el.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

      // Pointer down ≠ drag. We only enter drag mode (capture pointer + add
      // .is-dragging) once movement exceeds DRAG_THRESHOLD.
      var DRAG_THRESHOLD = 5;
      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;
      var activePointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isPointerDown = true;
        isDragging = false;
        moved = 0;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        activePointerId = e.pointerId;
        pauseFor(60000);
      });

      el.addEventListener('pointermove', function (e) {
        if (!isPointerDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!isDragging) {
          if (moved <= DRAG_THRESHOLD) return;
          isDragging = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(activePointerId); } catch (_) {}
        }
        var next = startScroll - dx;
        if (half > 0) {
          while (next < 0) {
            next += half;
            startScroll += half;
          }
          while (next >= half) {
            next -= half;
            startScroll -= half;
          }
        }
        el.scrollLeft = next;
      });

      function endDrag(e) {
        if (!isPointerDown) return;
        isPointerDown = false;
        var wasDragging = isDragging;
        isDragging = false;
        el.classList.remove('is-dragging');
        if (activePointerId !== null) {
          try { el.releasePointerCapture(activePointerId); } catch (_) {}
          activePointerId = null;
        }
        if (wasDragging) {
          var swallow = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            el.removeEventListener('click', swallow, true);
          };
          el.addEventListener('click', swallow, true);
        }
        pauseFor(1500);
      }
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      var onMotionChange = function () {
        if (reduceMotion.matches) {
          paused = true;
        } else {
          paused = false;
          lastTime = null;
        }
      };
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', onMotionChange);
      } else if (reduceMotion.addListener) {
        reduceMotion.addListener(onMotionChange);
      }
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-nz-testi-scroller]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class NzProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('#nz-product-form');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.saveEl = this.querySelector('[data-save]');
      this.variantLabel = this.querySelector('[data-variant-label]');
      this.addBtn = this.querySelector('[data-add-button]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.buyNowWrapper = this.querySelector('[data-buynow-wrapper]');
      this.mainImage = this.querySelector('[data-main-image]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));

      // Sticky add-to-cart bar
      this.stickyBar = this.querySelector('[data-sticky-atc]');
      this.stickyPriceEl = this.querySelector('[data-sticky-price]');
      this.stickyAddBtn = this.querySelector('[data-sticky-add-btn]');
      this.stickyAddLabel = this.querySelector('[data-sticky-add-label]');

      // Move it to be a direct child of <body>. `position: fixed` stops
      // being fixed to the viewport if ANY ancestor has a CSS transform —
      // even a finished, resting one, like this theme's scroll-reveal
      // fade-ins leave behind — and instead pins relative to that ancestor,
      // so the bar would scroll away once that ancestor left the viewport.
      // Relocating it here sidesteps that regardless of which ancestor (or
      // future animation) is responsible.
      if (this.stickyBar && this.stickyBar.parentElement !== document.body) {
        document.body.appendChild(this.stickyBar);
      }

      // Variant dropdown — the <select> fires "change"; hand its selected <option>
      // (which carries the same data-* attributes the old radios did) to onVariantChange.
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.variantInputs = Array.from(this.querySelectorAll('[data-variant-input]'));
      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', () => {
          const opt = this.variantSelect.options[this.variantSelect.selectedIndex];
          if (opt) this.onVariantChange(opt);
        });
      }

      // Quantity steppers
      this.qtyInput = this.querySelector('[data-qty-input]');
      this.qtyButtons = Array.from(this.querySelectorAll('[data-qty-step]'));
      this.qtyButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled || !this.qtyInput || this.qtyInput.disabled) return;
          const step = parseInt(btn.dataset.qtyStep, 10);
          const next = Math.max(1, parseInt(this.qtyInput.value, 10) + step);
          this.qtyInput.value = next;
        });
      });

      // Thumb clicks (stop autoplay on user interaction)
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.stopGalleryAutoplay();
          this.swapMainMedia(thumb);
        });
      });

      // Stable handler refs so add/remove pair up correctly across swaps.
      this._onVideoEnded = () => this.advanceGallery();

      // Gallery autoplay
      this.startGalleryAutoplay();

      // Copy share URL
      const copyBtn = this.querySelector('[data-copy-url]');
      if (copyBtn) {
        copyBtn.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(copyBtn.dataset.url);
            const original = copyBtn.textContent;
            copyBtn.textContent = 'Copied';
            setTimeout(() => { copyBtn.textContent = original; }, 1600);
          } catch {
            window.prompt('Copy link:', copyBtn.dataset.url);
          }
        });
      }

      // Intercept ATC submit → AJAX add → open Shopflo cart drawer
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.onAddToCart(e));
      }

      // Sticky add-to-cart bar: appears once you've scrolled past the real
      // button, disappears once you scroll back above it. Its click just
      // re-submits the real form — no cart logic duplicated — and its
      // price/label/disabled state stay mirrored to the real button via
      // MutationObserver so it automatically follows variant changes.
      //
      // Uses a locked scroll threshold (measured once after load, and again
      // on resize) rather than a live IntersectionObserver on the button
      // itself — that was flipping the bar on/off unpredictably whenever
      // anything elsewhere on the page reflowed (images/fonts settling,
      // third-party widgets injecting content), since any reflow makes the
      // browser recompute intersection even without the user scrolling.
      // Comparing scroll position to a fixed number sidesteps that entirely.
      if (this.stickyBar && this.addBtn) {
        const atcButtonsRow = this.querySelector('.nz-pdp__buttons') || this.addBtn;
        const waFab = document.querySelector('.nz-wa-fab');

        const applyVisibility = (isVisible) => {
          this.stickyBar.classList.toggle('is-visible', isVisible);
          document.body.classList.toggle('has-sticky-bottom-bar', isVisible);

          if (isVisible) {
            const barHeight = this.stickyBar.getBoundingClientRect().height;
            document.documentElement.style.setProperty('--nz-sticky-bar-height', `${barHeight}px`);
            if (waFab) {
              const waMargin = parseFloat(getComputedStyle(waFab).getPropertyValue('--nz-wa-margin')) || 24;
              waFab.style.bottom = `${waMargin + barHeight}px`;
            }
          } else if (waFab) {
            waFab.style.bottom = '';
          }
        };

        // Checks the real button's LIVE position on every scroll tick,
        // rather than caching a threshold measured once. A cached value
        // goes stale if anything above the button (certifications row,
        // reward banner, images) finishes settling into its final size
        // after the threshold was captured — a live check self-corrects
        // regardless of when that settling happens.
        let stickyTicking = false;
        const onStickyScroll = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(() => {
            const rect = atcButtonsRow.getBoundingClientRect();
            applyVisibility(rect.bottom < 0);
            stickyTicking = false;
          });
        };

        onStickyScroll();
        window.addEventListener('scroll', onStickyScroll, { passive: true });
        window.addEventListener('resize', onStickyScroll);
        window.addEventListener('load', onStickyScroll);

        if (this.stickyAddBtn) {
          this.stickyAddBtn.addEventListener('click', () => {
            if (this.form && typeof this.form.requestSubmit === 'function') {
              this.form.requestSubmit(this.addBtn);
            } else if (this.addBtn) {
              this.addBtn.click();
            }
          });
        }

        const syncStickyBar = () => {
          if (this.priceEl && this.stickyPriceEl) {
            this.stickyPriceEl.textContent = this.priceEl.textContent;
          }
          if (this.addBtn && this.stickyAddBtn) {
            this.stickyAddBtn.disabled = this.addBtn.disabled;
            this.stickyAddBtn.classList.toggle('loading', this.addBtn.classList.contains('loading'));
          }
          if (this.addLabel && this.stickyAddLabel) {
            this.stickyAddLabel.textContent = this.addLabel.textContent;
          }
        };
        syncStickyBar();
        if (this.priceEl) {
          new MutationObserver(syncStickyBar).observe(this.priceEl, {
            childList: true,
            characterData: true,
            subtree: true,
          });
        }
        if (this.addBtn) {
          new MutationObserver(syncStickyBar).observe(this.addBtn, {
            attributes: true,
            attributeFilter: ['disabled', 'class', 'aria-busy'],
            childList: true,
            subtree: true,
            characterData: true,
          });
        }
      }
    }

    async onAddToCart(evt) {
      evt.preventDefault();
      if (!this.addBtn || this.addBtn.disabled || this.addBtn.getAttribute('aria-busy') === 'true') return;

      this.addBtn.setAttribute('aria-busy', 'true');
      this.addBtn.classList.add('loading');

      try {
        const formData = new FormData(this.form);
        const response = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        });
        const json = await response.json();

        if (!response.ok) {
          console.error('Add to cart failed:', json);
          return;
        }

        // Refresh the header cart icon bubble
        try {
          const sectionsResp = await fetch('?sections=cart-icon-bubble');
          const sections = await sectionsResp.json();
          const bubbleHTML = sections['cart-icon-bubble'];
          if (bubbleHTML) {
            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              const parsed = new DOMParser().parseFromString(bubbleHTML, 'text/html');
              const fresh = parsed.querySelector('#cart-icon-bubble');
              if (fresh) bubble.innerHTML = fresh.innerHTML;
            }
          }
        } catch (e) { /* best-effort cart bubble refresh */ }

        // Open Shopflo cart drawer
        if (typeof window.handleFloCartBtn === 'function') {
          window.handleFloCartBtn();
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.addBtn.removeAttribute('aria-busy');
        this.addBtn.classList.remove('loading');
      }
    }

    onVariantChange(input) {
      // Update active card
      this.variantInputs.forEach((i) => {
        const label = i.closest('label');
        if (label) label.classList.toggle('is-active', i === input);
      });

      // Price + compare + savings
      if (this.priceEl) this.priceEl.textContent = input.dataset.price;
      const onSale = input.dataset.onSale === 'true';
      if (this.compareEl) {
        this.compareEl.hidden = !onSale;
        this.compareEl.textContent = input.dataset.compare;
      }
      if (this.saveEl) {
        this.saveEl.hidden = !onSale;
        if (onSale) {
          this.saveEl.textContent = `${input.dataset.pct}% off`;
        }
      }

      // Variant title in legend
      if (this.variantLabel) this.variantLabel.textContent = input.dataset.title;

      // Add-to-cart button state — single Sold Out button on PDP, hide Buy Now when unavailable.
      const available = input.dataset.available === 'true';
      if (this.addBtn) this.addBtn.disabled = !available;
      if (this.addLabel) this.addLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (this.buyNowWrapper) this.buyNowWrapper.hidden = !available;

      // Quantity stepper state — disable when sold out and reset to 1.
      if (this.qtyInput) {
        this.qtyInput.disabled = !available;
        if (!available) this.qtyInput.value = 1;
      }
      if (this.qtyButtons) {
        this.qtyButtons.forEach((b) => { b.disabled = !available; });
      }

      // Swap main image if variant has its own
      const imageId = input.dataset.imageId;
      if (imageId) {
        const matchingThumb = this.thumbs.find((t) => t.dataset.mediaId === imageId);
        if (matchingThumb) this.swapMainMedia(matchingThumb);
      }

      // Update URL with ?variant=
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      } catch (e) { /* ignore */ }
    }

    activeStage() {
      return this.mainImage && this.mainImage.querySelector('[data-stage]:not([hidden])');
    }

    swapMainMedia(thumb) {
      if (!this.mainImage) return;
      const targetId = thumb.dataset.mediaId;
      const current = this.activeStage();
      const next = this.mainImage.querySelector(`[data-stage][data-media-id="${CSS.escape(targetId)}"]`);

      // Always reflect the requested thumb as active, even if we can't find the
      // matching stage (defensive — keeps UI consistent with user intent).
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      if (!next || next === current) return;

      // Pause + reset outgoing video so it doesn't keep playing in the background.
      if (current && current.tagName === 'VIDEO') {
        current.removeEventListener('ended', this._onVideoEnded);
        try { current.pause(); current.currentTime = 0; } catch (e) { /* ignore */ }
      }

      if (current) current.hidden = true;
      next.hidden = false;

      const isVideo = next.tagName === 'VIDEO';
      if (isVideo) {
        // Muted is required for programmatic .play() under autoplay policies.
        next.muted = true;
        const p = next.play();
        if (p && p.catch) p.catch(() => { /* user-gesture-required; rely on poster */ });
      }

      // Carousel autoplay scheduling: image → interval, video → wait for ended.
      if (this.dataset.galleryAutoplay === 'true' && this.thumbs.length > 1) {
        this.clearGalleryTimer();
        if (isVideo) {
          next.addEventListener('ended', this._onVideoEnded, { once: true });
        } else {
          this.scheduleGalleryAdvance();
        }
      }
    }

    advanceGallery() {
      if (!this.thumbs || this.thumbs.length < 2) return;
      const idx = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
      const next = this.thumbs[(idx + 1) % this.thumbs.length];
      if (next) this.swapMainMedia(next);
    }

    scheduleGalleryAdvance() {
      const interval = parseInt(this.dataset.galleryInterval, 10) || 5000;
      this._galleryTimer = window.setTimeout(() => this.advanceGallery(), interval);
    }

    clearGalleryTimer() {
      if (this._galleryTimer) {
        window.clearTimeout(this._galleryTimer);
        this._galleryTimer = null;
      }
    }

    startGalleryAutoplay() {
      if (this.dataset.galleryAutoplay !== 'true') return;
      if (!this.thumbs || this.thumbs.length < 2) return;
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;

      // Kick off based on what's actually showing right now.
      const stage = this.activeStage();
      if (stage && stage.tagName === 'VIDEO') {
        stage.muted = true;
        const p = stage.play();
        if (p && p.catch) p.catch(() => {});
        stage.addEventListener('ended', this._onVideoEnded, { once: true });
      } else {
        this.scheduleGalleryAdvance();
      }

      // Pause on hover/focus, resume on leave.
      if (this.mainImage) {
        const pause = () => {
          this.clearGalleryTimer();
          const v = this.mainImage.querySelector('video[data-stage]:not([hidden])');
          if (v) {
            v.removeEventListener('ended', this._onVideoEnded);
            try { v.pause(); } catch (e) { /* ignore */ }
          }
        };
        const resume = () => {
          if (this.dataset.galleryAutoplay !== 'true') return;
          const s = this.activeStage();
          if (s && s.tagName === 'VIDEO') {
            s.muted = true;
            const p = s.play();
            if (p && p.catch) p.catch(() => {});
            s.addEventListener('ended', this._onVideoEnded, { once: true });
          } else if (!this._galleryTimer) {
            this.scheduleGalleryAdvance();
          }
        };
        this.mainImage.addEventListener('mouseenter', pause);
        this.mainImage.addEventListener('mouseleave', resume);
        this.mainImage.addEventListener('focusin', pause);
        this.mainImage.addEventListener('focusout', resume);
      }
    }

    stopGalleryAutoplay() {
      this.dataset.galleryAutoplay = 'false';
      this.clearGalleryTimer();
      const v = this.mainImage && this.mainImage.querySelector('video[data-stage]:not([hidden])');
      if (v) v.removeEventListener('ended', this._onVideoEnded);
    }

    disconnectedCallback() {
      this.clearGalleryTimer();
      if (this.mainImage) {
        this.mainImage.querySelectorAll('video[data-stage]').forEach((v) => {
          v.removeEventListener('ended', this._onVideoEnded);
          try { v.pause(); } catch (e) { /* ignore */ }
        });
      }
    }
  }

  if (!customElements.get('nz-product-form')) {
    customElements.define('nz-product-form', NzProductForm);
  }

  /* ── Horizontal tabs for the PDP details section (tablist + panels) ── */
  class NzPdpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (e) => this.onKeydown(e));
      });

      // Theme editor: activate the matching tab when its block/panel is selected.
      this.panels.forEach((panel) => {
        panel.addEventListener('shopify:block:select', () => {
          const tab = this.tabs.find((t) => t.getAttribute('aria-controls') === panel.id);
          if (tab) this.activate(tab, false);
        });
      });
    }

    activate(tab, focus = true) {
      this.tabs.forEach((t) => {
        const selected = t === tab;
        t.classList.toggle('is-active', selected);
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
      });
      const targetId = tab.getAttribute('aria-controls');
      this.panels.forEach((p) => { p.hidden = p.id !== targetId; });
      if (focus) tab.focus();
    }

    onKeydown(e) {
      const idx = this.tabs.indexOf(e.target);
      if (idx === -1) return;
      let next = null;
      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          next = this.tabs[(idx + 1) % this.tabs.length];
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
          break;
        case 'Home':
          next = this.tabs[0];
          break;
        case 'End':
          next = this.tabs[this.tabs.length - 1];
          break;
        default:
          return;
      }
      e.preventDefault();
      this.activate(next);
    }
  }

  if (!customElements.get('nz-pdp-tabs')) {
    customElements.define('nz-pdp-tabs', NzPdpTabs);
  }

  // Certifications strip: auto-scrolls, and can be grabbed/dragged (mouse or touch).
  // Fully independent of NzProductForm / NzPdpTabs above — only reads data attributes it owns.
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return; // CSS already renders a static wrapped row in this case.

    var wraps = document.querySelectorAll('.nz-pdp-certs--scroll');

    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('.nz-pdp-certs__track');
      if (!track) return;

      var repeats = parseInt(wrap.dataset.certsRepeats, 10) || 4;
      var durationSeconds = parseFloat(wrap.dataset.certsSpeed) || 18;
      var pauseOnHover = wrap.dataset.certsPause === 'true';

      var setWidth = 0;
      var offset = 0;
      var lastTime = null;
      var isDragging = false;
      var isHovering = false;
      var isVisible = false;
      var initialized = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var dragMoved = false;

      function debounce(fn, wait) {
        var t;
        return function () {
          clearTimeout(t);
          t = setTimeout(fn, wait);
        };
      }

      function measure() {
        setWidth = track.scrollWidth / repeats;
      }

      function applyTransform() {
        if (!setWidth) {
          track.style.transform = 'translateX(0)';
          return;
        }
        var wrapped = ((offset % setWidth) + setWidth) % setWidth;
        track.style.transform = 'translateX(' + -wrapped + 'px)';
      }

      function tick(now) {
        if (!isVisible) return; // Fully stops the loop once scrolled out of view.
        if (lastTime === null) lastTime = now;
        var dt = now - lastTime;
        lastTime = now;

        if (!isDragging && setWidth > 0 && !(pauseOnHover && isHovering)) {
          offset += (setWidth / (durationSeconds * 1000)) * dt;
          applyTransform();
        }
        requestAnimationFrame(tick);
      }

      function bindInteractions() {
        track.addEventListener('pointerdown', function (e) {
          isDragging = true;
          dragMoved = false;
          dragStartX = e.clientX;
          dragStartOffset = offset;
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        });
        track.addEventListener('pointermove', function (e) {
          if (!isDragging) return;
          var delta = dragStartX - e.clientX;
          if (Math.abs(delta) > 3) dragMoved = true;
          offset = dragStartOffset + delta;
          applyTransform();
        });
        function endDrag() {
          isDragging = false;
          lastTime = null;
        }
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('pointerleave', function () {
          if (isDragging) endDrag();
        });
        // Prevent a drag gesture from being misread as a click on the badge underneath.
        track.addEventListener('click', function (e) {
          if (dragMoved) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        if (pauseOnHover) {
          wrap.addEventListener('mouseenter', function () { isHovering = true; });
          wrap.addEventListener('mouseleave', function () { isHovering = false; });
        }
      }

      // Defer measuring, listeners, and the animation loop until this strip is
      // actually near the viewport — so it never competes for main-thread time
      // during initial page load (e.g. with video/reel players elsewhere on the page).
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
          if (isVisible) {
            if (!initialized) {
              initialized = true;
              measure();
              window.addEventListener('resize', debounce(measure, 200));
              track.querySelectorAll('img').forEach(function (img) {
                if (!img.complete) img.addEventListener('load', measure, { once: true });
              });
              bindInteractions();
            }
            lastTime = null;
            requestAnimationFrame(tick);
          }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(wrap);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-hero"] && !Shopify.designMode) return;
  try {
    
  class NzHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.nz-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.nz-hero__dot'));
      if (this.slides.length === 0) return;

      this.activeIndex = 0;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(i);
        });
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduceMotion) {
        this.intervalMs = parseInt(this.dataset.interval, 10) || 6000;
        this.style.setProperty('--nz-hero-interval', `${this.intervalMs}ms`);
        this.classList.add('is-autoplay');
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        document.addEventListener('visibilitychange', this.handleVisibility);
      }
    }

    handleVisibility = () => {
      if (document.hidden) this.stopAutoplay();
      else if (this.dataset.autoplay === 'true') this.startAutoplay();
    };

    goTo(index) {
      if (index === this.activeIndex) return;
      const total = this.slides.length;
      const next = ((index % total) + total) % total;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === next));
      this.dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === next);
        d.setAttribute('aria-selected', i === next ? 'true' : 'false');
      });
      this.activeIndex = next;
      if (this.classList.contains('is-autoplay') && this.timer) {
        this.scheduleNext();
        this.restartActiveFill();
      }
    }

    scheduleNext() {
      this.clearTimer();
      this.timer = window.setInterval(() => {
        this.goTo(this.activeIndex + 1);
      }, this.intervalMs);
    }

    startAutoplay() {
      this.clearTimer();
      this.classList.remove('is-paused');
      this.restartActiveFill();
      this.scheduleNext();
    }

    stopAutoplay() {
      this.clearTimer();
      if (this.classList.contains('is-autoplay')) {
        this.classList.add('is-paused');
      }
    }

    clearTimer() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartActiveFill() {
      const activeDot = this.dots[this.activeIndex];
      if (!activeDot) return;
      const fill = activeDot.querySelector('.nz-hero__dot-fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.handleVisibility);
    }
  }

  if (!customElements.get('nz-hero-carousel')) {
    customElements.define('nz-hero-carousel', NzHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-milind-picks"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(el) {
      if (el.dataset.nzPicksReady === '1') return;
      el.dataset.nzPicksReady = '1';

      var track = el.querySelector('.nz-picks-scroller__track');
      if (!track) return;

      var duration = parseFloat(el.dataset.duration) || 60;
      // Liquid renders exactly two identical passes. Capture the pass size
      // BEFORE any cloning so the loop period stays correct after we extend.
      var cardsPerPass = Math.floor(track.children.length / 2);
      var half = 0;

      function measure() {
        // Loop period = offset between corresponding cards in pass 1 and
        // pass 2. Exact accounting for the inter-card gap so the wrap is
        // visually seamless.
        var cards = track.children;
        if (cards.length <= cardsPerPass || cardsPerPass === 0) { half = 0; return; }
        half = cards[cardsPerPass].offsetLeft - cards[0].offsetLeft;
      }

      function ensureCoverage() {
        // For the auto-loop (and the user's native swipe / wheel) to wrap
        // forward at all, the wrap point must be reachable — i.e. the track
        // must be wider than the viewport by at least one pass. When one pass
        // is narrower than the viewport (e.g. only 6 cards on a wide screen),
        // append more passes until that's true.
        if (cardsPerPass === 0) return;
        measure();
        if (half <= 0) return;
        var guard = 8;
        while (track.scrollWidth - el.clientWidth < half + 1 && guard-- > 0) {
          for (var i = 0; i < cardsPerPass; i++) {
            var clone = track.children[i].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button').forEach(function (n) {
              n.setAttribute('tabindex', '-1');
            });
            track.appendChild(clone);
          }
        }
        measure();
      }
      ensureCoverage();

      window.addEventListener('resize', ensureCoverage);

      var pxPerMs = 0;
      function recomputeSpeed() {
        pxPerMs = duration > 0 ? half / (duration * 1000) : 0;
      }
      recomputeSpeed();

      var paused = reduceMotion.matches;
      var resumeTimer = null;
      var lastTime = null;
      // Track scroll position internally as a float. Mobile browsers (iOS
      // Safari in particular) round el.scrollLeft when read, so the
      // sub-pixel-per-frame increment never accumulates via `+=`.
      var pos = el.scrollLeft;

      function pauseFor(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (!reduceMotion.matches) {
            pos = el.scrollLeft;
            paused = false;
            lastTime = null;
          }
        }, ms);
      }

      function step(t) {
        recomputeSpeed();
        if (lastTime === null) lastTime = t;
        var dt = t - lastTime;
        lastTime = t;
        if (!paused && half > 0 && pxPerMs > 0) {
          pos += pxPerMs * dt;
          // Seamless loop: when we pass the duplicate boundary, jump back by
          // one pass-width — the content is identical so it's invisible.
          if (pos >= half) pos -= half;
          el.scrollLeft = pos;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);

      // Native swipe / wheel: pause briefly so the user keeps control.
      el.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
      el.addEventListener('touchstart', function () { pauseFor(3000); }, { passive: true });
      el.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

      // Desktop pointer drag.
      // Pointer down ≠ drag. We only enter drag mode (capture pointer + add
      // .is-dragging) once movement exceeds DRAG_THRESHOLD. Adding the class
      // on pointerdown would set pointer-events:none on the card <a>, which
      // retargets the subsequent mouseup/click off the link and prevents
      // products from opening on a plain click.
      var DRAG_THRESHOLD = 5;
      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;
      var activePointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isPointerDown = true;
        isDragging = false;
        moved = 0;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        activePointerId = e.pointerId;
        pauseFor(60000);
      });

      el.addEventListener('pointermove', function (e) {
        if (!isPointerDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!isDragging) {
          if (moved <= DRAG_THRESHOLD) return;
          isDragging = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(activePointerId); } catch (_) {}
        }
        var next = startScroll - dx;
        // Wrap during back-drag so users can browse past the visible edge.
        if (half > 0) {
          while (next < 0) {
            next += half;
            startScroll += half;
          }
          while (next >= half) {
            next -= half;
            startScroll -= half;
          }
        }
        el.scrollLeft = next;
      });

      function endDrag(e) {
        if (!isPointerDown) return;
        isPointerDown = false;
        var wasDragging = isDragging;
        isDragging = false;
        el.classList.remove('is-dragging');
        if (activePointerId !== null) {
          try { el.releasePointerCapture(activePointerId); } catch (_) {}
          activePointerId = null;
        }
        // If the user actually dragged, swallow the next click so cards
        // don't navigate at drop-time.
        if (wasDragging) {
          var swallow = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            el.removeEventListener('click', swallow, true);
          };
          el.addEventListener('click', swallow, true);
        }
        pauseFor(1500);
      }
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      // Respect reduced-motion changes at runtime.
      var onMotionChange = function () {
        if (reduceMotion.matches) {
          paused = true;
        } else {
          paused = false;
          lastTime = null;
        }
      };
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', onMotionChange);
      } else if (reduceMotion.addListener) {
        reduceMotion.addListener(onMotionChange);
      }
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-nz-picks-scroller]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    // Re-init when the theme editor reloads or adds this section.
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-on-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(el) {
      if (el.dataset.nzSaleReady === '1') return;
      el.dataset.nzSaleReady = '1';

      var track = el.querySelector('.nz-sale-scroller__track');
      if (!track) return;

      var duration = parseFloat(el.dataset.duration) || 60;
      // Liquid renders exactly two identical passes. Capture the pass size
      // BEFORE any cloning so the loop period stays correct after we extend.
      var cardsPerPass = Math.floor(track.children.length / 2);
      var half = 0;

      function measure() {
        var cards = track.children;
        if (cards.length <= cardsPerPass || cardsPerPass === 0) { half = 0; return; }
        half = cards[cardsPerPass].offsetLeft - cards[0].offsetLeft;
      }

      function ensureCoverage() {
        // Wrap point must be reachable via native scroll — append more
        // passes until track.scrollWidth - clientWidth >= half.
        if (cardsPerPass === 0) return;
        measure();
        if (half <= 0) return;
        var guard = 8;
        while (track.scrollWidth - el.clientWidth < half + 1 && guard-- > 0) {
          for (var i = 0; i < cardsPerPass; i++) {
            var clone = track.children[i].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('a, button').forEach(function (n) {
              n.setAttribute('tabindex', '-1');
            });
            track.appendChild(clone);
          }
        }
        measure();
      }
      ensureCoverage();

      window.addEventListener('resize', ensureCoverage);

      var pxPerMs = 0;
      function recomputeSpeed() {
        pxPerMs = duration > 0 ? half / (duration * 1000) : 0;
      }
      recomputeSpeed();

      var paused = reduceMotion.matches;
      var resumeTimer = null;
      var lastTime = null;
      // Track scroll position internally as a float. Mobile browsers (iOS
      // Safari in particular) round el.scrollLeft when read, so the
      // sub-pixel-per-frame increment never accumulates via `+=`.
      var pos = el.scrollLeft;

      function pauseFor(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (!reduceMotion.matches) {
            pos = el.scrollLeft;
            paused = false;
            lastTime = null;
          }
        }, ms);
      }

      function step(t) {
        recomputeSpeed();
        if (lastTime === null) lastTime = t;
        var dt = t - lastTime;
        lastTime = t;
        if (!paused && half > 0 && pxPerMs > 0) {
          pos += pxPerMs * dt;
          if (pos >= half) pos -= half;
          el.scrollLeft = pos;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);

      el.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
      el.addEventListener('touchstart', function () { pauseFor(3000); }, { passive: true });
      el.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

      // Pointer down ≠ drag. We only enter drag mode (capture pointer + add
      // .is-dragging) once movement exceeds DRAG_THRESHOLD. Adding the class
      // on pointerdown would set pointer-events:none on the card <a>, which
      // retargets the subsequent mouseup/click off the link and prevents
      // products from opening on a plain click.
      var DRAG_THRESHOLD = 5;
      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;
      var activePointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isPointerDown = true;
        isDragging = false;
        moved = 0;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        activePointerId = e.pointerId;
        pauseFor(60000);
      });

      el.addEventListener('pointermove', function (e) {
        if (!isPointerDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!isDragging) {
          if (moved <= DRAG_THRESHOLD) return;
          isDragging = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(activePointerId); } catch (_) {}
        }
        var next = startScroll - dx;
        if (half > 0) {
          while (next < 0) {
            next += half;
            startScroll += half;
          }
          while (next >= half) {
            next -= half;
            startScroll -= half;
          }
        }
        el.scrollLeft = next;
      });

      function endDrag(e) {
        if (!isPointerDown) return;
        isPointerDown = false;
        var wasDragging = isDragging;
        isDragging = false;
        el.classList.remove('is-dragging');
        if (activePointerId !== null) {
          try { el.releasePointerCapture(activePointerId); } catch (_) {}
          activePointerId = null;
        }
        if (wasDragging) {
          var swallow = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            el.removeEventListener('click', swallow, true);
          };
          el.addEventListener('click', swallow, true);
        }
        pauseFor(1500);
      }
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      var onMotionChange = function () {
        if (reduceMotion.matches) {
          paused = true;
        } else {
          paused = false;
          lastTime = null;
        }
      };
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', onMotionChange);
      } else if (reduceMotion.addListener) {
        reduceMotion.addListener(onMotionChange);
      }
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-nz-sale-scroller]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-pillars"] && !Shopify.designMode) return;
  try {
    
  class NzPillars extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.nz-pillars-section__card-wrap'));
      if (this.cards.length === 0) return;
      this.handleScroll = this.handleScroll.bind(this);
      this.ticking = false;
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleScroll, { passive: true });
      this.handleScroll();
    }

    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const vh = window.innerHeight;
        const trigger = vh * 0.45;
        let activeIndex = -1;
        this.cards.forEach((wrap, i) => {
          const card = wrap.querySelector('.nz-pillars-section__card');
          if (!card) return;
          const r = card.getBoundingClientRect();
          if (r.top <= trigger) activeIndex = i;
        });
        this.cards.forEach((wrap, i) => {
          wrap.classList.toggle('is-stacked', i < activeIndex);
        });
        this.ticking = false;
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
  }
  if (!customElements.get('nz-pillars')) {
    customElements.define('nz-pillars', NzPillars);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-rakhi-banner"] && !Shopify.designMode) return;
  try {
    
  class RakhiCountdown extends HTMLElement {
    connectedCallback() {
      const end = Date.parse(this.dataset.end);
      if (isNaN(end)) {
        this.remove();
        return;
      }

      const daysEl = this.querySelector('[data-rb-days]');
      const hoursEl = this.querySelector('[data-rb-hours]');
      const minutesEl = this.querySelector('[data-rb-minutes]');
      const secondsEl = this.querySelector('[data-rb-seconds]');
      const self = this;

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        const diff = end - Date.now();
        if (diff <= 0) {
          self.classList.add('is-ended');
          clearInterval(self._rbTimer);
          return;
        }
        const s = Math.floor(diff / 1000);
        const days = Math.floor(s / 86400);
        const hours = Math.floor((s % 86400) / 3600);
        const minutes = Math.floor((s % 3600) / 60);
        const seconds = s % 60;
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      this._rbTimer = setInterval(tick, 1000);
    }

    disconnectedCallback() {
      clearInterval(this._rbTimer);
    }
  }
  if (!customElements.get('rakhi-countdown')) {
    customElements.define('rakhi-countdown', RakhiCountdown);
  }

  (function () {
    'use strict';
    document.querySelectorAll('[data-rb-copy]').forEach(function (btn) {
      if (btn.dataset.rbCopyReady === '1') return;
      btn.dataset.rbCopyReady = '1';
      btn.addEventListener('click', function () {
        var code = btn.dataset.code || '';
        var hint = btn.querySelector('[data-rb-copy-hint]');
        var restore = hint ? hint.textContent : '';
        function done(ok) {
          if (!hint) return;
          hint.textContent = ok ? 'Copied!' : 'Copy failed';
          btn.classList.toggle('is-copied', ok);
          setTimeout(function () {
            hint.textContent = restore;
            btn.classList.remove('is-copied');
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () { done(true); },
            function () { done(false); }
          );
        } else {
          done(false);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-video-feed"] && !Shopify.designMode) return;
  try {
    
  // Lazy-load video sources: each video only downloads once IT individually
  // nears the viewport — never all of them at once, and never as a blanket
  // "page finished loading" fallback (that defeated lazy-loading entirely).
  (function () {
    var section = document.getElementById('hear-from-them');
    if (!section) return;

    function play(video) {
      try {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function hydrateOne(video) {
      if (video.dataset.nzHydrated === 'true') return;
      video.dataset.nzHydrated = 'true';

      var sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      sources.forEach(function (src) {
        src.setAttribute('src', src.getAttribute('data-src'));
        src.removeAttribute('data-src');
      });
      video.preload = 'auto';
      video.removeAttribute('data-nz-lazy-video');
      try { video.load(); } catch (e) {}

      if (video.readyState >= 2) {
        play(video);
      } else {
        video.addEventListener('loadedmetadata', function () { play(video); }, { once: true });
        video.addEventListener('canplay', function () { play(video); }, { once: true });
      }
    }

    var allVideos = section.querySelectorAll('video[data-nz-lazy-video]');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hydrateOne(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' });
      allVideos.forEach(function (v) { io.observe(v); });
    } else {
      // No IntersectionObserver support → hydrate immediately so it still works.
      allVideos.forEach(hydrateOne);
    }

    // Re-kick when the tab becomes visible again (some browsers pause
    // autoplaying videos in background tabs).
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      section.querySelectorAll('.nz-video-tile__video').forEach(function (v) {
        if (v.dataset.nzHydrated === 'true' && v.paused) play(v);
      });
    });
  })();

  // Horizontal auto-scroll marquee with manual drag / swipe / wheel control.
  // Self-contained, mirrors the proven nz-on-sale / nz-milind-picks rails so
  // this row behaves identically to "What's Trending" / "Powered by Protein".
  (function () {
    'use strict';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(el) {
      if (el.dataset.nzVideoReady === '1') return;
      el.dataset.nzVideoReady = '1';

      var track = el.querySelector('.nz-video-track');
      if (!track) return;

      var duration = parseFloat(el.dataset.duration) || 50;
      // Liquid renders exactly two identical passes. Capture the pass size
      // BEFORE any cloning so the loop period stays correct after we extend.
      var cardsPerPass = Math.floor(track.children.length / 2);
      var half = 0;

      function measure() {
        var cards = track.children;
        if (cards.length <= cardsPerPass || cardsPerPass === 0) { half = 0; return; }
        half = cards[cardsPerPass].offsetLeft - cards[0].offsetLeft;
      }

      function ensureCoverage() {
        // Wrap point must be reachable via native scroll — append more passes
        // until the track is wider than the viewport by at least one pass.
        if (cardsPerPass === 0) return;
        measure();
        if (half <= 0) return;
        var guard = 8;
        while (track.scrollWidth - el.clientWidth < half + 1 && guard-- > 0) {
          for (var i = 0; i < cardsPerPass; i++) {
            var clone = track.children[i].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.querySelectorAll('a, button, [tabindex]').forEach(function (n) {
              n.setAttribute('tabindex', '-1');
            });
            track.appendChild(clone);
          }
        }
        measure();
      }
      ensureCoverage();

      window.addEventListener('resize', ensureCoverage);

      var pxPerMs = 0;
      function recomputeSpeed() {
        pxPerMs = duration > 0 ? half / (duration * 1000) : 0;
      }
      recomputeSpeed();

      var paused = reduceMotion.matches;
      var resumeTimer = null;
      var lastTime = null;
      // Track scroll position internally as a float. Mobile browsers round
      // el.scrollLeft when read, so a sub-pixel-per-frame increment never
      // accumulates via `+=`.
      var pos = el.scrollLeft;

      function pauseFor(ms) {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          if (!reduceMotion.matches) {
            pos = el.scrollLeft;
            paused = false;
            lastTime = null;
          }
        }, ms);
      }

      function step(t) {
        recomputeSpeed();
        if (lastTime === null) lastTime = t;
        var dt = t - lastTime;
        lastTime = t;
        if (!paused && half > 0 && pxPerMs > 0) {
          pos += pxPerMs * dt;
          if (pos >= half) pos -= half;
          el.scrollLeft = pos;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);

      // Native swipe / wheel: pause briefly so the user keeps control.
      el.addEventListener('wheel', function () { pauseFor(1500); }, { passive: true });
      el.addEventListener('touchstart', function () { pauseFor(3000); }, { passive: true });
      el.addEventListener('touchend', function () { pauseFor(1500); }, { passive: true });

      // Desktop pointer drag. Pointer down ≠ drag: only enter drag mode once
      // movement exceeds DRAG_THRESHOLD, so a plain click still opens the reel.
      var DRAG_THRESHOLD = 5;
      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var moved = 0;
      var activePointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isPointerDown = true;
        isDragging = false;
        moved = 0;
        startX = e.clientX;
        startScroll = el.scrollLeft;
        activePointerId = e.pointerId;
        pauseFor(60000);
      });

      el.addEventListener('pointermove', function (e) {
        if (!isPointerDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!isDragging) {
          if (moved <= DRAG_THRESHOLD) return;
          isDragging = true;
          el.classList.add('is-dragging');
          try { el.setPointerCapture(activePointerId); } catch (_) {}
        }
        var next = startScroll - dx;
        if (half > 0) {
          while (next < 0) {
            next += half;
            startScroll += half;
          }
          while (next >= half) {
            next -= half;
            startScroll -= half;
          }
        }
        el.scrollLeft = next;
      });

      function endDrag() {
        if (!isPointerDown) return;
        isPointerDown = false;
        var wasDragging = isDragging;
        isDragging = false;
        el.classList.remove('is-dragging');
        if (activePointerId !== null) {
          try { el.releasePointerCapture(activePointerId); } catch (_) {}
          activePointerId = null;
        }
        // If the user actually dragged, swallow the next click so tiles don't
        // navigate at drop-time.
        if (wasDragging) {
          var swallow = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            el.removeEventListener('click', swallow, true);
          };
          el.addEventListener('click', swallow, true);
        }
        pauseFor(1500);
      }
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);

      var onMotionChange = function () {
        if (reduceMotion.matches) {
          paused = true;
        } else {
          paused = false;
          lastTime = null;
        }
      };
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', onMotionChange);
      } else if (reduceMotion.addListener) {
        reduceMotion.addListener(onMotionChange);
      }
    }

    function boot(root) {
      (root || document).querySelectorAll('[data-nz-video-scroller]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target);
    });
  })();

  // Shoppable reel lightbox + tile actions (like, share, add to cart).
  // Fully independent of the marquee/hydration code above.
  (function () {
    var section = document.getElementById('hear-from-them');
    if (!section) return;

    var payloadEl = section.querySelector('[data-nz-reel-payload]');
    var reels = [];
    try { reels = JSON.parse((payloadEl && payloadEl.textContent) || '[]'); } catch (e) { reels = []; }

    var lightbox = document.querySelector('[data-nz-reel-lightbox]');
    var lbVideo = lightbox && lightbox.querySelector('[data-nz-reel-video]');
    var lbViews = lightbox && lightbox.querySelector('[data-nz-reel-views]');
    var lbLikes = lightbox && lightbox.querySelector('[data-nz-reel-likes]');
    var lbLikesCount = lightbox && lightbox.querySelector('[data-nz-reel-likes-count]');
    var lbShares = lightbox && lightbox.querySelector('[data-nz-reel-shares]');
    var lbSharesCount = lightbox && lightbox.querySelector('[data-nz-reel-shares-count]');
    var lbProductLink = lightbox && lightbox.querySelector('[data-nz-reel-product-link]');
    var lbProductImage = lightbox && lightbox.querySelector('[data-nz-reel-product-image]');
    var lbProductName = lightbox && lightbox.querySelector('[data-nz-reel-product-name]');
    var lbPrice = lightbox && lightbox.querySelector('[data-nz-reel-price]');
    var lbCompare = lightbox && lightbox.querySelector('[data-nz-reel-compare]');
    var lbOff = lightbox && lightbox.querySelector('[data-nz-reel-off]');
    var lbAdd = lightbox && lightbox.querySelector('[data-nz-reel-add]');
    var lbMute = lightbox && lightbox.querySelector('[data-nz-reel-mute]');

    var currentIndex = -1;
    var lastFocused = null;

    function buyNow(variantId, button) {
      if (!variantId || !button || button.disabled) return;
      button.disabled = true;
      button.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (typeof window.handleFloBuyNowBtn === 'function') {
            // handleFloBuyNowBtn reads the variant from the <form> the button
            // sits inside (that's how it works on the PDP). Reel buttons have
            // no such form, so build a temporary one with the right variant,
            // fire the handler as if it were clicked from inside it, then
            // remove it. This mirrors the PDP's working button exactly.
            var tempForm = document.createElement('form');
            tempForm.action = '/cart/add';
            tempForm.method = 'post';
            tempForm.style.display = 'none';
            var idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.name = 'id';
            idInput.value = variantId;
            tempForm.appendChild(idInput);
            var qtyInput = document.createElement('input');
            qtyInput.type = 'hidden';
            qtyInput.name = 'quantity';
            qtyInput.value = '1';
            tempForm.appendChild(qtyInput);
            var tempButton = document.createElement('button');
            tempButton.type = 'button';
            tempForm.appendChild(tempButton);
            document.body.appendChild(tempForm);

            try {
              window.handleFloBuyNowBtn({ target: tempButton, preventDefault: function () {} });
            } catch (err) {
              // Shopflo's handler threw — fall back rather than leave the
              // shopper stuck with an item added but nowhere to go.
              if (typeof window.handleFloCartBtn === 'function') {
                window.handleFloCartBtn();
              } else {
                window.location.href = '/cart';
              }
            }
            setTimeout(function () { tempForm.remove(); }, 3000);
            button.disabled = false;
            button.textContent = 'Buy Now';
          } else if (typeof window.handleFloCartBtn === 'function') {
            // Shopflo's direct-checkout handler isn't available for some
            // reason — open its cart drawer instead (same proven hook the
            // PDP's regular Add to cart flow already uses).
            window.handleFloCartBtn();
            button.disabled = false;
            button.textContent = 'Buy Now';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          button.textContent = 'Try again';
          setTimeout(function () {
            button.disabled = false;
            button.textContent = 'Buy Now';
          }, 1800);
        });
    }

    function shareReel() {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).catch(function () {});
      }
    }

    // Tile-level actions: like (decorative toggle), share, add to cart.
    // These stop propagation so they never also trigger the lightbox open.
    section.addEventListener('click', function (e) {
      var likeBtn = e.target.closest('[data-nz-tile-like]');
      if (likeBtn) {
        e.stopPropagation();
        likeBtn.classList.toggle('is-liked');
        return;
      }
      var shareBtn = e.target.closest('[data-nz-tile-share]');
      if (shareBtn) {
        e.stopPropagation();
        shareReel();
        return;
      }
      var addBtn = e.target.closest('[data-nz-tile-add]');
      if (addBtn) {
        e.stopPropagation();
        buyNow(addBtn.dataset.variantId, addBtn);
        return;
      }
    });

    function populateLightbox(index) {
      var reel = reels[index];
      if (!reel || !lightbox) return;
      currentIndex = index;

      while (lbVideo.firstChild) lbVideo.removeChild(lbVideo.firstChild);
      (reel.sources || []).forEach(function (src) {
        var s = document.createElement('source');
        s.src = src.url;
        s.type = src.type;
        lbVideo.appendChild(s);
      });
      lbVideo.load();
      lbVideo.muted = lbMute ? lbMute.classList.contains('is-muted') : true;
      var p = lbVideo.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});

      if (lbViews) lbViews.textContent = reel.views != null ? reel.views + ' Views' : '';
      if (lbLikesCount) lbLikesCount.textContent = reel.likes != null ? reel.likes : '';
      if (lbSharesCount) lbSharesCount.textContent = reel.shares != null ? reel.shares : '';

      var hasProduct = !!reel.productTitle;
      if (lbProductLink) {
        lbProductLink.hidden = !hasProduct;
        if (hasProduct) lbProductLink.href = reel.productUrl || '#';
      }
      if (lbProductImage && hasProduct) lbProductImage.src = reel.productImage || '';
      if (lbProductName) lbProductName.textContent = reel.productTitle || '';
      if (lbPrice) lbPrice.textContent = reel.price || '';
      if (lbCompare) {
        if (reel.comparePrice) {
          lbCompare.textContent = reel.comparePrice;
          lbCompare.hidden = false;
        } else {
          lbCompare.hidden = true;
        }
      }
      if (lbOff) {
        if (reel.percentOff > 0) {
          lbOff.textContent = reel.percentOff + '% Off';
          lbOff.hidden = false;
        } else {
          lbOff.hidden = true;
        }
      }
      if (lbAdd) {
        lbAdd.hidden = !hasProduct;
        lbAdd.disabled = hasProduct ? !reel.available : true;
        lbAdd.textContent = hasProduct ? (reel.available ? 'Buy Now' : 'Sold out') : '';
        lbAdd.dataset.variantId = reel.variantId || '';
        lbAdd.classList.remove('is-added');
      }
    }

    function openLightbox(index) {
      if (!lightbox || !reels.length) return;
      lastFocused = document.activeElement;
      populateLightbox(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lbAdd) lbAdd.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lbVideo) {
        lbVideo.pause();
        while (lbVideo.firstChild) lbVideo.removeChild(lbVideo.firstChild);
      }
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function step(delta) {
      if (!reels.length) return;
      var next = (currentIndex + delta + reels.length) % reels.length;
      populateLightbox(next);
    }

    // Open on click or keyboard (Enter/Space) from any tile.
    section.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-nz-reel-open]');
      if (!tile) return;
      if (e.target.closest('[data-nz-tile-add], [data-nz-tile-like], [data-nz-tile-share]')) return;
      var index = parseInt(tile.dataset.reelIndex, 10);
      if (!isNaN(index)) openLightbox(index);
    });
    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tile = e.target.closest('[data-nz-reel-open]');
      if (!tile) return;
      e.preventDefault();
      var index = parseInt(tile.dataset.reelIndex, 10);
      if (!isNaN(index)) openLightbox(index);
    });

    if (lightbox) {
      lightbox.querySelectorAll('[data-nz-reel-close]').forEach(function (btn) {
        btn.addEventListener('click', closeLightbox);
      });
      var prevBtn = lightbox.querySelector('[data-nz-reel-prev]');
      var nextBtn = lightbox.querySelector('[data-nz-reel-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      if (lbMute) {
        lbMute.addEventListener('click', function () {
          lbMute.classList.toggle('is-muted');
          if (lbVideo) lbVideo.muted = lbMute.classList.contains('is-muted');
        });
      }
      if (lbAdd) {
        lbAdd.addEventListener('click', function () {
          buyNow(lbAdd.dataset.variantId, lbAdd);
        });
      }

      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') step(1);
        if (e.key === 'ArrowLeft') step(-1);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = html.trim();
          const fresh = wrapper.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) {
            this.innerHTML = fresh.innerHTML;
          }
        })
        .catch(() => {
          // network/CORS/etc — keep the fallback
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
